import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, Phone, Globe } from 'lucide-react';
import { PAGES } from '@/app/pages';
import './SiteFooter.css';

export default function SiteFooter() {
  const { t } = useTranslation();
  const navPages = PAGES.filter((p) => p.key !== 'home');

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer-inner">
        {/* brand */}
        <div className="footer-brand">
          <Link to="/" className="footer-logo-link" aria-label={t('nav.brand')}>
            <span className="brand-logo footer-logo" role="img" aria-label={t('nav.brand')} />
          </Link>
          <p className="footer-about">{t('footer.about')}</p>
          <p className="footer-tagline">{t('contact.tagline')}</p>
        </div>

        {/* navigate */}
        <nav className="footer-col" aria-label={t('footer.navTitle')}>
          <h3 className="footer-col-title">{t('footer.navTitle')}</h3>
          <ul>
            {navPages.map((p) => (
              <li key={p.key}>
                <Link to={p.path} className="footer-link">
                  {t(`nav.pages.${p.key}`)}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* contact */}
        <div className="footer-col footer-col--contact">
          <h3 className="footer-col-title">{t('footer.contactTitle')}</h3>
          <ul>
            <li>
              <a className="footer-link footer-link--icon" href={`mailto:${t('contact.email')}`}>
                <Mail size={15} /> {t('contact.email')}
              </a>
            </li>
            <li>
              <a className="footer-link footer-link--icon" href={`tel:${t('contact.phone').replace(/\s/g, '')}`}>
                <Phone size={15} />{' '}
                <span dir="ltr">{t('contact.phone')}</span>
              </a>
            </li>
            <li>
              <a className="footer-link footer-link--icon" href="https://www.valionco.com" target="_blank" rel="noreferrer">
                <Globe size={15} /> {t('contact.web')}
              </a>
            </li>
            <li>
              <a
                className="footer-link footer-link--icon"
                href="https://www.linkedin.com/company/valion-company"
                target="_blank"
                rel="noreferrer"
              >
                <Linkedin size={15} /> {t('contact.linkedin')}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="site-footer-bar">
        <span className="footer-rights">{t('contact.rights')}</span>
        <span className="footer-edition">{t('footer.edition')}</span>
      </div>
    </footer>
  );
}
